import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.898 10.778A1 1 0 1 1 .483 9.363l3.333-3.332.007-.007a1.457 1.457 0 0 1 2.039 0l.007.007L7.57 7.732 9.917 5.25l-1.04-1.04a.75.75 0 0 1 .53-1.28h3.653a.75.75 0 0 1 .75.75v3.652a.75.75 0 0 1-1.28.53l-1.198-1.198-2.704 2.86-.027.028a1.457 1.457 0 0 1-2.04 0l-.006-.007-1.713-1.712z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const moneyGraphArrowIncrease = { render };
export {
  moneyGraphArrowIncrease as default,
  render
};
//# sourceMappingURL=money-graph-arrow-increase.svg.js.map
